import '../../themes/default/borderRadius/index.js';
import '../../themes/default/borderWidth/index.js';
import { ColorAll } from '../../themes/default/color/index.js';
import '../../themes/default/shape/index.js';
import '../../themes/default/size/index.js';
import '../../themes/default/spacing/index.js';
import '../../theming/themes/caviar.js';
import '../../theming/themes/merchant.js';
import '../../theming/themes/merchant-next.js';
import '../../theming/themes/internal-tools.js';
import '../../theming/icons/constants.js';
import '../../theming/logo/constants.js';
import '../../theming/typography/constants.js';
import 'lodash.clonedeep';
import 'lodash.merge';
import 'react';
import '../../themes/default/textStyle/textStyle-legacy-semantics.js';
import '../../themes/default/textStyle/textStyle-legacy-tokens.js';
import { TextStyleSemanticsAll } from '../../themes/default/textStyle/textStyle-semantics.js';
import get from 'lodash.get';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var generateThemedFontFamily = function generateThemedFontFamily() {
  var primaryFont = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DD-TTNorms';
  return "\n  ".concat(primaryFont, ",\n  -apple-system,\n  BlinkMacSystemFont,\n  \"Segoe UI\",\n  Roboto,\n  Helvetica,\n  Arial,\n  sans-serif,\n  \"Apple Color Emoji\",\n  \"Segoe UI Emoji\",\n  \"Segoe UI Symbol\"\n");
};
var getStylesOptions = function getStylesOptions() {
  var stylesOptions = {};
  Object.keys(TextStyleSemanticsAll).forEach(function (styleName) {
    stylesOptions[styleName] = "".concat(styleName);
  });
  return stylesOptions;
};
var returnFontFamilyValues = function returnFontFamilyValues(fontBrand) {
  return {
    SansSerif: "\n      ".concat(generateThemedFontFamily(fontBrand), "\n    "),
    Serif: "\n      DD-SourceSerifPro,\n      Georgia,\n      ".concat(generateThemedFontFamily(fontBrand), "\n    ")
  };
};
var createBaseTextColors = function createBaseTextColors() {
  var colorsObj = {
    CurrentColor: 'currentColor'
  };
  Object.keys(ColorAll).forEach(function (colorName) {
    colorsObj[colorName] = colorName;
    colorsObj[ColorAll[colorName]] = ColorAll[colorName];
  });
  return colorsObj;
};
createBaseTextColors();
var getFontWeightString = function getFontWeightString(weightString) {
  var defaultWeightString = weightString.split('-');
  return defaultWeightString[defaultWeightString.length - 1];
};
var getTextStyleValues = function getTextStyleValues(_ref) {
  var allValues = _ref.allValues,
      density = _ref.density;
  // Always fall back to the RegularDensity, MobileWidth values
  // - these are defined for every TextStyle Semantic
  var defaultValues = get(allValues, 'RegularDensity.MobileWidth');
  var desktopValues = {}; // If > Breakpoints.Mobile viewport, override defaults with any
  // DesktopWidth values available

  if (get(allValues, 'RegularDensity.DesktopWidth')) {
    desktopValues = _objectSpread({}, allValues.RegularDensity.DesktopWidth);
  }

  if (density !== 'Regular' && allValues[density]) {
    // Override with any values defined in the theme's Density object
    defaultValues = _objectSpread(_objectSpread({}, defaultValues), allValues[density].MobileWidth); // If > Breakpoints.Mobile viewport, override with any values
    // defined in the theme Density's object DesktopWidth object

    if (allValues[density].DesktopWidth) {
      desktopValues = _objectSpread(_objectSpread({}, desktopValues), allValues[density].DesktopWidth);
    }
  } // We need to convert the weight strings from the theme definitions
  // to proper CSS values in order to apply them as expected when passed
  // through to the `TextElement` styled component


  if (defaultValues.weight) {
    defaultValues.weight = getFontWeightString(defaultValues.weight);
  }

  if (desktopValues.weight) {
    desktopValues.weight = getFontWeightString(desktopValues.weight);
  }

  return {
    defaultValues: defaultValues,
    desktopValues: desktopValues
  };
}; // `getThemeTextStyleValues` is used to pass back any style overrides
// that are defined in the theme. This util is used for supporting the modern,
// Theming-based typography system (where the `styles` value (e.g. `Text.Styles`) is not
// an object of styling properties (the legacy structure) but is instead a single string value)
// for when any combination of the `styles`, `mobileStyles`, `tabletStyles`, `desktopStyles`,
// and `wideScreenStyles` props are defined in a given `<Text />` instance

var getThemeTextStyleValues = function getThemeTextStyleValues(_ref2) {
  var completeSemanticDefinition = _ref2.completeSemanticDefinition,
      themeDensityString = _ref2.themeDensityString,
      defaults = _ref2.defaults,
      includeDesktopOverrides = _ref2.includeDesktopOverrides;
  var textStyleValues = getTextStyleValues({
    allValues: completeSemanticDefinition,
    density: themeDensityString
  });

  if (includeDesktopOverrides) {
    return _objectSpread(_objectSpread(_objectSpread({}, defaults), textStyleValues.defaultValues), textStyleValues.desktopValues);
  }

  return _objectSpread(_objectSpread({}, defaults), textStyleValues.defaultValues);
};

export { createBaseTextColors, generateThemedFontFamily, getFontWeightString, getStylesOptions, getTextStyleValues, getThemeTextStyleValues, returnFontFamilyValues };
